import { Divider, Stack } from '@ltvco/refresh-lib/theme';
import { titleize } from '@ltvco/refresh-lib/utils';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import PersonIcon from '@mui/icons-material/Person';

import {
  ChevronButton,
  TeaserAvatar,
  TeaserDetailLabel,
  TeaserDetailRow,
  TeaserDetailValue,
  TeaserInfo,
  TeaserItemContainer,
  TeaserItemRow,
  TeaserName,
} from '../components';
import { formatRelatives } from '../utils';

import type { PersonSearchData } from 'components/DeepSearch/types';

interface PersonSearchPreviewCardProps {
  data: PersonSearchData;
  onTeaserClick?: (
    displayName: string,
    idType: string,
    idValue: string
  ) => void;
}

export const PersonSearchPreviewCard = ({
  data,
  onTeaserClick,
}: PersonSearchPreviewCardProps) => {
  if (!data.teasers.length) {
    return null;
  }

  return (
    <Stack divider={<Divider />}>
      {data.teasers.map((teaser, index) => {
        const displayName = titleize(teaser.name.toLowerCase());
        return (
          <TeaserItemContainer
            key={teaser.bvId || index}
            onClick={() => onTeaserClick?.(displayName, 'bv_id', teaser.bvId)}
          >
            <TeaserItemRow>
              <TeaserAvatar>
                <PersonIcon fontSize="small" />
              </TeaserAvatar>
              <TeaserInfo>
                <TeaserName variant="body1">
                  {titleize(teaser.name.toLowerCase())}
                  {teaser.age ? `, ${teaser.age}` : ''}
                </TeaserName>
                <TeaserDetailRow>
                  <TeaserDetailLabel variant="body2">
                    Date of Birth:
                  </TeaserDetailLabel>
                  <TeaserDetailValue variant="body2">
                    {teaser.birthYear || '-'}
                  </TeaserDetailValue>
                </TeaserDetailRow>
                <TeaserDetailRow>
                  <TeaserDetailLabel variant="body2">
                    Locations:
                  </TeaserDetailLabel>
                  <TeaserDetailValue variant="body2">
                    {teaser.location
                      ? titleize(teaser.location.toLowerCase())
                      : '-'}
                  </TeaserDetailValue>
                </TeaserDetailRow>
                <TeaserDetailRow>
                  <TeaserDetailLabel variant="body2">
                    Relatives:
                  </TeaserDetailLabel>
                  <TeaserDetailValue variant="body2">
                    {formatRelatives(teaser.relatives, {
                      titleizeParts: true,
                    }) || '-'}
                  </TeaserDetailValue>
                </TeaserDetailRow>
              </TeaserInfo>
              <ChevronButton>
                <ChevronRightIcon fontSize="small" />
              </ChevronButton>
            </TeaserItemRow>
          </TeaserItemContainer>
        );
      })}
    </Stack>
  );
};
